import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { projectMutationKeys, projectQueryKeys } from '../constants'
import { customQueryClient } from '../../config/query-client'

export const useCreateProjectMutation = (options) => {
  const handleVerifyNameIsAvailable = async (projectName) => {
    const config = {
      method: 'get',
      params: {
        name: projectName
      }
    }

    const { data } = await api('/api/projects/name', config)
    return data
  }

  const handleFunction = async ({ projectName, parentFolderId }) => {
    const isProjectNameAvailable =
      await handleVerifyNameIsAvailable(projectName)

    if (!isProjectNameAvailable) {
      throw new Error('Project name is not available')
    }

    const config = {
      method: 'post',
      data: {
        name: projectName,
        parentId: parentFolderId
      }
    }

    const { data } = await api('/api/projects', config)
    return data
  }

  const invalidateRelatedQueries = () => {
    customQueryClient.invalidateQueries({
      queryKey: [projectQueryKeys.GET_PROJECT_TREE_QUERY]
    })
    customQueryClient.invalidateQueries({
      queryKey: [projectQueryKeys.GET_PROJECT_LIMIT_QUERY]
    })
  }

  return useMutation({
    mutationKey: projectMutationKeys.CREATE_PROJECT,
    mutationFn: handleFunction,
    retry: 0,
    ...options,
    onSuccess: (data, requestParams, context) => {
      invalidateRelatedQueries()

      // Call user callback with all original parameters
      options?.onSuccess?.(data, requestParams, context)
    },
    onError: (error, requestParams, context) => {
      options?.onError?.(error, requestParams, context)
    }
  })
}
